import { render, staticRenderFns } from "./LensGuestInvitationModal.vue?vue&type=template&id=b3012db4&scoped=true"
import script from "./LensGuestInvitationModal.vue?vue&type=script&lang=js"
export * from "./LensGuestInvitationModal.vue?vue&type=script&lang=js"
import style0 from "./LensGuestInvitationModal.vue?vue&type=style&index=0&id=b3012db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3012db4",
  null
  
)

export default component.exports